import React from "react";
import { Nav, Container } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import pdf from "../File/Manuale.pdf";
import useLocalStorage from "../Utility/useLocalStorage"

function NavbarCustom(props) {
  const [localStorage, setLocalStorage, removeLocalStorage] = useLocalStorage("LoginUser");

  return (
    <>


      <Navbar>
        <Container fluid>
        <Navbar.Brand href="#">ChatBot Tool</Navbar.Brand>
        <Nav
              className="me-auto my-2 my-lg-0"
              style={{ maxHeight: "100px" }}
              navbarScroll
            >
              <Nav.Link href="#StatoCivile">Stato Civile</Nav.Link>
              <Nav.Link href={pdf}>Aiuto</Nav.Link>
              {!localStorage ? (<>
                <Nav.Link href="/login">Login</Nav.Link>
              </>)
                :
                <Nav.Link href="/" onClick={() => removeLocalStorage()}>Logout</Nav.Link>


}
            </Nav>


          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
          {localStorage && (<>
            <Navbar.Text>
              <b>Utente: {" "}</b>
            {localStorage.email}
            </Navbar.Text>
                </>)}
            
          </Navbar.Collapse>
        </Container>
      </Navbar>


    </>
  );
}

export default NavbarCustom;
